import axios from 'axios';

const API_URL = 'https://rzurh612h4.execute-api.us-east-1.amazonaws.com/prod/investment_round';

export const GetAllInvestmentRounds = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    console.log("InvestmentAPIHelper :: GetAllInvestmentRounds :: response :: " + response)
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const UpdateInvestmentRound = async (investmentRoundId, investmentRoundName) => {
    try {
      const url = `${API_URL}?investmentRoundId=${investmentRoundId}`;
      const requestBody = {
        investment_round_id: investmentRoundId,
        investment_round_name: investmentRoundName
      };
  
      const response = await axios.put(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`
        },
      });
  
      if (response.status === 200) {
        return response;
      } else {
        console.error('Error:', response.status, response.statusText);
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
};

export const DeleteInvestmentRound = async (investmentRoundId) => {
  try {
    const url = `${API_URL}?investmentRoundId=${investmentRoundId}`;

    const response = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
